import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ConnectView from "@/views/ConnectView.vue";
import NotFoundView from "@/views/NotFoundView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
    meta: {
      title: "The NFT Marketplace",
    },
  },
  {
    path: "/create",
    name: "Create",
    component: () => import("@/views/CreateView.vue"),
    meta: {
      title: "Create New Item",
    },
  },
  {
    path: "/connect",
    name: "Connect",
    component: ConnectView,
    meta: {
      title: "Sign In",
      layout: "AppLayoutFullpage",
    },
  },
  {
    path: "/users/:id",
    name: "UserDetails",
    component: () => import("@/views/UserDetailsView.vue"),
    meta: {
      title: "User Details",
    },
  },
  {
    path: "/collection/:assetContract",
    component: () => import("@/views/CollectionView.vue"),
    children: [
      {
        path: "items/:id",
        name: "ItemDetails",
        component: () => import("@/views/ItemDetailsView.vue"),
        meta: {
          title: "Item Details",
        },
      },
      {
        path: "items/:id/offer",
        name: "ItemOffer",
        component: () => import("@/views/ItemOfferView.vue"),
        meta: {
          title: "Item Offer",
          layout: "AppLayoutFullpage",
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFoundView,
    meta: {
      title: "404",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
